import { CONTACT_ATTRIBUTES as SET_ATTRIBUTES } from "./actions";
import React from "react";

let initialState = null;

export const reducer = (state = initialState, action) => {
	switch (action.type) {
	case SET_ATTRIBUTES:
		return action.attributes != null ? { ...action.attributes } : null;
		break;
	default:
		return state;
		break;
	}
};
